<template>
  <router-view />
</template>
<script>
//axios 전역으로 선언
import {onMounted} from 'vue'
import LogRocket from 'logrocket';
export default {
  name: "App",
  setup() {


    onMounted(() => {
      LogRocket.init('integrated-sugang-front/integrated-sugang-front');    
    })
  },
};
</script>
<style lang="scss"></style>
